import React from 'react';
import Marquee from 'react-fast-marquee';
import { CLIENTS } from '../../data/content';

export default function LogoTicker() {
  return (
    <section id="clients" data-testid="logo-ticker" className="relative py-12 border-y border-white/5 bg-black/30">
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-6">
        <p className="font-mono text-sm uppercase tracking-[0.25em] text-white/70 text-center font-bold">
          — Trusted by teams at —
        </p>
      </div>
      <div className="fade-edges">
        <Marquee gradient={false} speed={40} pauseOnHover>
          {CLIENTS.concat(CLIENTS).map((c, i) => (
            <div
              key={`${c.name}-${i}`}
              className="mx-10 flex items-center justify-center h-10"
            >
              <span className="text-white/80 font-bold text-base tracking-wide uppercase">
                {c.name}
              </span>
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
